







import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({
  name:'ISurvey'
})
export default class ISurvey extends Vue{
@Prop({ type: String, default() { return "#000000"; }})color!:string
@Prop({ type: String, default() { return "24"; }}) width!:string
@Prop({ type: String, default() { return "24"; }}) height!:string
}
